import { ETRIS04_CurrentStock } from "./ETRIS04_CurrentStock";

export const StockInquiryReport = {
    "sections": [ETRIS04_CurrentStock]
}